import React from 'react';

const TransparencySection = () => {
  return (
    <section className="py-20 px-6 ">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Activity Tracking & Audit Logs</h2>
            <p className="text-lg text-gray-600">Track every important action across your infrastructure. Monitor deployments,
  configuration changes, and system events with a complete audit trail.</p>
          </div>
          <div>
            <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm max-w-md mx-auto">
              <div className="flex items-center gap-2 mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-blue-600">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z" />
                </svg>
                <span className="font-medium text-gray-900">Recent Activity</span>
              </div>
              <div className="space-y-2">
                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                  <div>
                    <p className="text-sm font-medium text-gray-900">  Application Deployed
</p>
                    <p className="text-xs text-gray-600">  Production Environment
</p>
                  </div>
                  <span className="text-xs text-gray-600">  02:00 PM
</span>
                </div>
                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                  <div>
                    <p className="text-sm font-medium text-gray-900">Database Backup Completed
</p>
                    <p className="text-xs text-gray-600">  Backup Service
</p>
                  </div>
                  <span className="text-xs text-gray-600">10:30 AM</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TransparencySection;